(function(){
  'use strict';

  angular
    .module('app.floorplandetailrevamped', [
      'app.common',
      'app.forms',
      'ngLocationUpdate',
      'ngRoute',
      'ngTouch',
      'ngSanitize',
      'ui.bootstrap',
      '720kb.datepicker',
      'slickCarousel',
      'angular.filter',
      'youtube-embed',
      'angular-inview',
      'modules.dataServices',
      'modules.snapshotRange',
      'ngStorage',
      "app.login",
      "app.saved",
      "modules.authServices"
    ])

    .config(['$interpolateProvider', function($interpolateProvider) {
      $interpolateProvider.startSymbol('<%');
      $interpolateProvider.endSymbol('%>');
    }])

    .config(['$locationProvider', function($locationProvider) {
      $locationProvider.html5Mode({
        enabled: false,
        requireBase: true,
        rewriteLinks: false
      });
    }])
  ;

}());
